module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Sending-d776bbaa494f3cdf6976788bd2f17a51.svg";